
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 4v16.457h18.286v-12.8H15.8V4H3zm3.657 3.657h1.829v1.829H6.657V7.657zm3.657 0h1.829v1.829h-1.829V7.657zM15.8 9.486h3.657v9.143H15.8V16.8h1.829v-1.829H15.8v-1.828h1.829v-1.829H15.8V9.486zm-9.143 1.828h1.829v1.829H6.657v-1.829zm3.657 0h1.829v1.829h-1.829v-1.829zm-3.657 3.657h1.829V16.8H6.657v-1.829zm3.657 0h1.829V16.8h-1.829v-1.829z"}})])
          )
        }
      }
    